/* eslint-disable camelcase */

// localization resources
import ar_EG from './ar_EG.json';
import bg_BG from './bg_BG.json';
import cs_CZ from './cs_CZ.json';
import de_DE from './de_DE.json';
import en_GB from './en_GB.json';
import en_US from './en_US.json';
import es_ES from './es_ES.json';
import fr_FR from './fr_FR.json';
import lv_LV from './lv_LV.json';
import pl_PL from './pl_PL.json';
import pt_BR from './pt_BR.json';
import ro_RO from './ro_RO.json';
import ru_RU from './ru_RU.json';
import sk_SK from './sk_SK.json';
import sl_SI from './sl_SI.json';
import tr_TR from './tr_TR.json';
import uk_UA from './uk_UA.json';

export const resources = {
  'ar-EG': {
    translation: ar_EG,
  },
  'bg-BG': {
    translation: bg_BG,
  },
  'cs-CZ': {
    translation: cs_CZ,
  },
  'de-DE': {
    translation: de_DE,
  },
  'en-GB': {
    translation: en_GB,
  },
  'en-US': {
    translation: en_US,
  },
  'es-ES': {
    translation: es_ES,
  },
  'fr-FR': {
    translation: fr_FR,
  },
  'lv-LV': {
    translation: lv_LV,
  },
  'pl-PL': {
    translation: pl_PL,
  },
  'pt-BR': {
    translation: pt_BR,
  },
  'ro-RO': {
    translation: ro_RO,
  },
  'ru-RU': {
    translation: ru_RU,
  },
  'sk-SK': {
    translation: sk_SK,
  },
  'sl-SI': {
    translation: sl_SI,
  },
  'tr-TR': {
    translation: tr_TR,
  },
  'uk-UA': {
    translation: uk_UA,
  },
} as const;

export const supportedLocales = Object.keys(resources);
